import React, { useState, useEffect } from 'react';
import { Table, Form, Input, DatePicker, message, Button } from 'antd';
import { getAuditLogs } from '../services/api';
import moment from 'moment';

const { RangePicker } = DatePicker;

const AuditLogList = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [searchParams, setSearchParams] = useState({});

    const fetchAuditLogs = async (page = 1, pageSize = 10, params = {}) => {
        setLoading(true);
        try {
            const response = await getAuditLogs({ page, per_page: pageSize, ...params });
            setLogs(response.data.audit_logs);
            setPagination({ current: page, pageSize, total: response.data.total });
        } catch (error) {
            message.error('获取审计日志失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAuditLogs(pagination.current, pagination.pageSize, searchParams);
    }, []);

    const handleTableChange = (pagination) => {
        fetchAuditLogs(pagination.current, pagination.pageSize, searchParams);
    };

    const handleSearch = (values) => {
        const { timestamp_range, ...rest } = values;
        const params = {
            ...rest,
            timestamp_start: timestamp_range ? timestamp_range[0].format('YYYY-MM-DD') : '',
            timestamp_end: timestamp_range ? timestamp_range[1].format('YYYY-MM-DD') : '',
        };
        setSearchParams(params);
        fetchAuditLogs(1, pagination.pageSize, params);
    };

    const columns = [
        { title: 'ID', dataIndex: 'id' },
        { title: '用户ID', dataIndex: 'user_id' },
        { title: '用户名', dataIndex: 'username' },
        { title: '操作', dataIndex: 'action' },
        { title: '目标类型', dataIndex: 'target_type' },
        { title: '目标ID', dataIndex: 'target_id' },
        { title: '时间', dataIndex: 'timestamp' },
        { title: 'IP地址', dataIndex: 'ip_address' },
        { title: '详情', dataIndex: 'details' },
    ];

    return (
        <>
            <Form layout="inline" onFinish={handleSearch} style={{ marginBottom: 16 }}>
                <Form.Item name="username" label="用户名">
                    <Input placeholder="输入用户名" />
                </Form.Item>
                <Form.Item name="action" label="操作">
                    <Input placeholder="输入操作" />
                </Form.Item>
                <Form.Item name="target_type" label="目标类型">
                    <Input placeholder="输入目标类型" />
                </Form.Item>
                <Form.Item name="ip_address" label="IP地址">
                    <Input placeholder="输入IP地址" />
                </Form.Item>
                <Form.Item name="timestamp_range" label="时间范围">
                    <RangePicker />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        搜索
                    </Button>
                </Form.Item>
            </Form>

            <Table
                columns={columns}
                dataSource={logs}
                rowKey="id"
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
            />
        </>
    );
};

export default AuditLogList;
